module.exports = __webpack_public_path__ + "static/media/advanced-hand-ranking.d8133bd7.png";